import { render, staticRenderFns } from "./CompanyDocs.vue?vue&type=template&id=29376f42&scoped=true"
var script = {}
import style0 from "./CompanyDocs.vue?vue&type=style&index=0&id=29376f42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29376f42",
  null
  
)

export default component.exports